import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

const ToolbarGroupContainer = ({
  className,
  children,
  ...props
}) => createElement("div", _extends({
  className: className
}, props), children);

export default ToolbarGroupContainer;
//# sourceMappingURL=toolbar-group-container.js.map